
    <div class="modal-header">
        <button type="button" class="close" (click)="bsModalRef.hide()">×</button>
        <h4 class="modal-title" translate>{{ title }}</h4>
    </div>

    <div class="modal-body">
        <div class="row-fluid">
              <span class="warning-icon-wrap">
                  <span class="ss-alert icon">&nbsp;</span>
              </span>
        </div>
        <div class="row-fluid text-center">
            <p>
                <span translate>{{ message }}</span>
            </p>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn" (click)="bsModalRef.hide()" translate>Close</button>
    </div>
    